// document ready
jQuery(document).ready(function ($) {

    // form google maps address search
    function gform_google_maps(form,search,location,hidden) {

        // set up out vars
        let $form       = $(form);
        let $search     = $(search);
        let $location   = $(location);
        let $hidden     = $(hidden);

        //console.log($hidden);

        // set the map at local point
        let map = new google.maps.Map($form[0], {
            center: {
                lat: 25.0750095,
                lng: 55.1887609
            },
            zoom: 9
        });

        // set up the search input
        let input = $search[0];

        // var input = document.getElementById(form);
        let autocomplete = new google.maps.places.Autocomplete(input);

        // stop form submit on input enter
        input.addEventListener('keydown',(e) => {
            if(e.key === "Enter") {
                e.preventDefault();
                e.stopPropagation();
            }
        });

        // not sure
        autocomplete.bindTo('bounds', map);

        // get the geocode data
        autocomplete.setFields(
            ['address_components', 'formatted_address', 'geometry', 'icon', 'name', 'place_id']);

        // info window vars
        let infowindow = new google.maps.InfoWindow();
        let infowindowContent = document.getElementById('infowindow-order-checkout');

        // create info window content
        infowindow.setContent(infowindowContent);

        // set up our marker vars
        let marker = new google.maps.Marker({
            map: map,
            anchorPoint: new google.maps.Point(0, -29)
        });

        // when auto complete fires
        autocomplete.addListener('place_changed', function () {

            infowindow.close();
            marker.setVisible(false);
            let place = autocomplete.getPlace();

            // populate the location field with google result
            $location.val(place.address_components[1].long_name);

            // lets create our acf data object
            let acf_json = {
                //name : place.name,
                //address : place.formatted_address,
                lat : place.geometry.location.lat(),
                lng : place.geometry.location.lng(),
                place_id : place.place_id
            };

            //console.log(JSON.stringify(acf_json));

            // lets update the d-none field with our acf object
            $hidden.attr('value',JSON.stringify(acf_json));

            // if no geometry
            if (!place.geometry) {
                window.alert("No details available for input: '" + place.name + "'");
                return;
            }

            // set the info window map position
            if (place.geometry.viewport) {
                map.fitBounds(place.geometry.viewport);
            } else {
                map.setCenter(place.geometry.location);
                map.setZoom(17);
            }
            marker.setPosition(place.geometry.location);
            marker.setVisible(true);

            // not sure
            let address = '';
            if (place.address_components) {
                address = [
                    (place.address_components[0] && place.address_components[0].short_name || ''),
                    (place.address_components[1] && place.address_components[1].short_name || ''),
                    (place.address_components[2] && place.address_components[2].short_name || '')
                ].join(' ');
            }

            // info window
            infowindowContent.children['place-icon'].src = place.icon;
            infowindowContent.children['place-name'].textContent = place.name;
            infowindowContent.children['place-address'].textContent = address;
            infowindow.open(map, marker);

        });

        // on resize do stuff
        $(window).resize(function() {

            google.maps.event.trigger(map, 'resize');

        });

    }

    // code to trigger hacks on ajax gravity form render
    $(document).on('gform_post_render', function(event, form_id) {

        // order checkout form
        if (form_id === 1) {

            gform_google_maps(
                '#map-order-checkout',
                '#input_1_4',
                '#input_1_7',
                '#input_1_25'
            );

        }

        // delivery quote form
        if (form_id === 3) {

            gform_google_maps(
                '#map-quote-delivery',
                '#input_3_3',
                '#input_3_7',
                '#input_3_11'
            );

        }

    });

    // code to trigger hacks on ajax gravity form confirmation loaded
    $(document).on('gform_confirmation_loaded', function(event, form_id) {

        // order checkout form
        if (form_id == 1) {

            // reload_cart_summary();

        }

    });


    // get delivery quote modal
    $('#modal-quote-delivery').on('shown.bs.modal', function () {

        // create modal as object
        let $modal = $(this);

        // if data loaded is false
        if( !$modal.data('loaded') ) {

            // jquery ajax call
            $.ajax({
                cache: false,
                timeout: 30000,
                url: admin_ajax_url,
                type: 'GET',
                data: {
                    action: 'reload_cart_quote_delivery_form'
                },
                success: function (data) {

                    // load the form into modal
                    $('.modal-content', '#modal-quote-delivery').html(data);

                    // set loaded to true
                    $modal.data('loaded',true);

                }
            });

        }

    });

    // get install quote modal
    $('#modal-quote-install').on('shown.bs.modal', function () {

        // create modal as object
        let $modal = $(this);

        // if data loaded is false
        if( !$modal.data('loaded') ) {

            // jquery ajax call
            $.ajax({
                cache: false,
                timeout: 30000,
                url: admin_ajax_url,
                type: 'GET',
                data: {
                    action: 'reload_cart_quote_install_form'
                },
                success: function (data) {

                    // load the form into modal
                    $('.modal-content', '#modal-quote-install').html(data);

                    // set loaded to true
                    $modal.data('loaded',true);

                }
            });

        }

    });

});